// import { useMutation } from "react-query";
// import axios from "axios";
// import { message } from "antd";

// const baseURL = process.env.REACT_APP_BASE_URL;

// export const useResetTutorPassword = () => {
//   return useMutation(
//     ({ email }: any) =>
//       axios
//         .post(`${baseURL}/tutors/reset-password`, { email: email })
//         .then((res: any) => res.data),
//     {
//       onSuccess: async (data: any) => {
//         message.success(data?.message);
//       },
//       onError: (error: any) => {
//         message.error(
//           error?.response?.data?.message ||
//             "Reset password failed. Please try again."
//         );
//       },
//     }
//   );
// };

import { useMutation } from "react-query";
import { message } from "antd";

// const baseURL =
//   window.location.hostname === "www.w2st.net"
//     ? process.env.REACT_APP_PROD_URL
//     : process.env.REACT_APP_BASE_URL;

export const useResetTutorPassword = () => {
  return useMutation(
    async ({ email }: { email: string }) => {
      const response = await fetch(
        "https://api.w2st.net/api/v1/tutors/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        // Throw formatted error so react-query's onError receives it
        // eslint-disable-next-line no-throw-literal
        throw {
          message: data?.message || "Reset password failed.",
          status: response.status,
        };
      }

      return data;
    },
    {
      onSuccess: (data: any) => {
        message.success(data?.message);
      },
      onError: (error: any) => {
        message.error(
          error?.message || "Reset password failed. Please try again."
        );
      },
    }
  );
};
